<div
  class="arrow-link-container"
  (click)="onClick()"
  (keyup.enter)="onClick()"
  tabindex="0"
>
  <svg
    width="11px"
    height="18px"
    viewBox="0 0 10 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="01.-Landing-Page"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <path
        transform="scale (-1, 1)" transform-origin="center"
        d="M9.7284857,7.37567987 L2.15369023,0.255607678 C1.97849445,0.0907960098 1.74462332,0 1.49525303,0 C1.24588274,0 1.01201161,0.0907960098 0.836815832,0.255607678 L0.278984739,0.779831058 C-0.0839998694,1.12142178 -0.0839998694,1.67660426 0.278984739,2.01767465 L6.63972608,7.99668295 L0.27192709,13.9823253 C0.0967313158,14.147137 0,14.3668425 0,14.6011171 C0,14.8356517 0.0967313158,15.0553573 0.27192709,15.220299 L0.829758183,15.7443923 C1.00509234,15.909204 1.23882509,16 1.48819538,16 C1.73756567,16 1.9714368,15.909204 2.14663258,15.7443923 L9.7284857,8.61781612 C9.90409663,8.45248413 10.0005512,8.23173795 10,7.99707319 C10.0005512,7.76149787 9.90409663,7.54088178 9.7284857,7.37567987 Z"
        id="ico_arrow_right"
        fill="#EC0000"
        fill-rule="nonzero"
      ></path>
    </g>
  </svg>
  <span
    class="arrow-link-text"
    [ngClass]="{'lato bold use-lato': useLato, 'oswald': !useLato}"
  >
    {{ text }}
  </span>
</div>
